import { ENDPOINTS } from '@config/endpoints';
import { authedJsonFetch, AuthedJsonFetchResult } from '@services/base/authed-json-fetch';
import { PaymentsConfirmPrepaymentRequestData, PaymentsConfirmPrepaymentResponseData } from '@services/dto/payments/payments-confirm-prepayment';
type PaymentsConfirmPrepayment = (requestData: PaymentsConfirmPrepaymentRequestData) => AuthedJsonFetchResult<PaymentsConfirmPrepaymentResponseData>;

/**
 * @deprecated
 * https://gitlab.com/freuders-development/freuders-frontend-web/-/issues/863
 */
export const paymentsConfirmPrepayment: PaymentsConfirmPrepayment = requestData => {
  return authedJsonFetch(ENDPOINTS.payments.confirmPrepayment(requestData.chatId),
  //
  {
    method: 'POST'
  });
};